import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { arrayOf, shape, string, number } from 'prop-types';
import { formatToCurrency, currencyToSign } from '../../utils/utils';

const getPreparedIfLongBalance = (value) =>
  `${value}`.length > 5 ? [value, '0,0'] : [value, '0,0.00'];

const propTypes = {
  balance: arrayOf(
    shape({
      currency: string,
      balance: number,
      hold: number,
    }),
  ),
};

const defaultProps = {
  balance: [
    {
      currency: '',
      balance: 0,
      hold: 0,
    },
  ],
};

const SlaveBalanceData = ({ balance }) => {
  const headerCurrency = useSelector(({ app: { headerCurrency } }) => headerCurrency);
  const account = balance[headerCurrency];
  return account ? (
    <ul className="balance-data">
      <li className="account.balance">
        <span className="balance-label">
          <FormattedMessage id="account.balance" defaultMessage="Balance" />:
        </span>
        <span className="balance-value">
          {formatToCurrency(...getPreparedIfLongBalance(account.balance))}
          &nbsp;
          {currencyToSign(account.currency)}
        </span>
      </li>
      <li className="account.hold">
        <span className="balance-label">
          <FormattedMessage id="account.hold" defaultMessage="Hold" />:
        </span>
        <span className="balance-value">
          {formatToCurrency(...getPreparedIfLongBalance(account.hold))}
          &nbsp;
          {currencyToSign(account.currency)}
        </span>
      </li>
    </ul>
  ) : null;
};

SlaveBalanceData.propTypes = propTypes;
SlaveBalanceData.defaultProps = defaultProps;

export default SlaveBalanceData;
